import React from "react";

const styles = `
.risk-print-sheet {
  width: 210mm;
  min-height: 297mm;
  box-sizing: border-box;
  background: #ffffff;
  color: #111827;
  padding: 14mm 12mm;
  font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  display: grid;
  gap: 10px;
  border: 1px solid #d1d5db;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.risk-print-sheet__header {
  display: grid;
  gap: 6px;
  border-bottom: 1px solid #cbd5e1;
  padding-bottom: 8px;
}

.risk-print-sheet__title {
  margin: 0;
  font-size: 24px;
  line-height: 1.15;
}

.risk-print-sheet__header-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.risk-print-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid #dbe3ee;
  font-size: 12px;
}

.risk-print-sheet__summary {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.risk-print-sheet__detail {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.risk-print-sheet__full {
  grid-column: 1 / -1;
}

.risk-print-card {
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  background: #f8fafc;
  padding: 10px;
  min-width: 0;
}

.risk-print-card__label {
  color: #64748b;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
}

.risk-print-card__value {
  font-size: 13px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.risk-print-card--score {
  position: relative;
  overflow: hidden;
}

.risk-print-card--score .risk-print-card__value {
  font-size: 20px;
  font-weight: 700;
}

.risk-print-score-band {
  margin-top: 6px;
  font-size: 11px;
  opacity: 0.92;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.risk-print-card__meta {
  color: #64748b;
  font-size: 11px;
  margin-top: 6px;
}

.risk-print-list {
  margin: 0;
  padding-left: 18px;
  display: grid;
  gap: 4px;
}

.risk-print-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.risk-print-badge-group {
  display: grid;
  gap: 8px;
}

.risk-print-summary-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.risk-print-summary-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 6px 10px;
  background: #e2e8f0;
  border: 1px solid #cbd5e1;
  font-size: 12px;
  font-weight: 600;
}

.risk-print-matrix-card {
  display: grid;
  gap: 10px;
}

.risk-print-matrix {
  display: grid;
  grid-template-columns: 28px repeat(5, minmax(0, 1fr));
  gap: 4px;
  align-items: stretch;
}

.risk-print-matrix__axis {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #475569;
  font-weight: 600;
}

.risk-print-matrix__cell {
  min-height: 42px;
  border-radius: 8px;
  padding: 4px;
  display: grid;
  align-content: space-between;
  border: 1px solid rgba(255,255,255,0.5);
}

.risk-print-matrix__score {
  font-size: 10px;
  font-weight: 700;
}

.risk-print-matrix__markers {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.risk-print-matrix__marker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: rgba(255,255,255,0.92);
  color: #0f172a;
  font-size: 10px;
  font-weight: 700;
}

.risk-print-matrix__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.risk-print-matrix__legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #475569;
}

.risk-print-screen-preview {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #e2e8f0;
  padding: 12px;
  overflow: auto;
}

[data-risk-print-root] {
  position: fixed;
  left: -200vw;
  top: 0;
  opacity: 0;
  pointer-events: none;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  body * {
    visibility: hidden !important;
  }

  [data-risk-print-root],
  [data-risk-print-root] * {
    visibility: visible !important;
  }

  [data-risk-print-root] {
    position: absolute !important;
    inset: 0 auto auto 0 !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    opacity: 1 !important;
  }

  .risk-print-sheet {
    width: 100%;
    min-height: auto;
    border: none;
    box-shadow: none;
    padding: 0;
    gap: 8px;
  }

  .risk-print-screen-preview,
  .modal-a11y-backdrop {
    display: none !important;
  }
}
`;

export default function RiskPrintStyles() {
  return (
    <style data-testid="risk-print-styles">
      {styles}
    </style>
  );
}
